
(function() {
  var result = { translations: { "da": { "foundations-components": { "ActionsMenu": { "defaultAriaLabel": "Handlinger" }, "tag": { "remove": "Fjern tag" }, "Select": { "noResults": "Ingen resultater fundet", "searchPlaceholder": "S\xF8g\u2026", "clearSelections": "Ryd valg" }, "ErrorMessage": { "error": { "title": "Alt er ikke tabt." }, "notFound": { "title": "Alle, der vandrer, er ikke tabt." }, "badRequest": { "title": "Der opstod et problem med at indl\xE6se siden." }, "expired": { "title": "Vi beklager." }, "sessionId": { "prefix": "Sessions-ID: " } }, "ProgressSteps": { "completedStep": "Gennemf\xF8rt trin", "incompleteStep": "Ufuldst\xE6ndigt trin" }, "Paginator": { "label": "Sidenumre", "pageNumber": { "currentIndicator": "Du er i \xF8jeblikket p\xE5", "description": "Side" }, "firstPage": { "label": "F\xF8rst", "description": "F\xF8rste side" }, "previousPage": { "label": "Forrige", "description": "Forrige side" }, "nextPage": { "label": "N\xE6ste", "description": "N\xE6ste side" }, "lastPage": { "label": "Sidste", "description": "Sidste side" } }, "Datagrid": { "noData": { "Title": "Ingen tilg\xE6ngelige data", "Description": "Der er ingen data at vise." }, "noResults": { "Title": "Ingen resultater fundet", "Description": "Pr\xF8v at justere s\xF8gningen og filtrene for at finde det, du leder efter.", "ClearActionLabel": "Ryd s\xF8gning og filtre" }, "toolbar": { "selectedRows": { "one": "{{count}} r\xE6kke valgt", "other": "{{count}} r\xE6kker valgt", "clearSelection": "Ryd valg", "selectAll": "V\xE6lg alle {{totalRows}} r\xE6kker" }, "search": { "placeholder": "S\xF8g", "label": "S\xF8g", "clearSearch": "Ryd s\xF8gning" } }, "pagination": { "visibleRows": "{{visibleRows}} af {{totalRows}} resultater", "itemsPerPage": "Elementer pr. side", "countPerPage": { "one": "{{count}} per side", "other": "{{count}} per side" } }, "SkeletonGrid": { "loading": "Indl\xE6ser" }, "DataGridColumnManagementPanel": { "description": "V\xE6lg, hvilke egenskaber der skal vises som kolonner. Flyt derefter egenskaber op eller ned, eller tr\xE6k og slip, for at \xE6ndre den r\xE6kkef\xF8lge, de skal vises i.", "removeAllColumns": "Fjern alle kolonner", "update": "Opdater", "cancel": "Annuller", "edit": "Rediger kolonner" } } }, "ui": { "UIAbstractPageSection": { "page": "Sideafsnit" }, "UICarousel": { "current": "Viser emne {{currentStepDisplayNumber}} ud af {{totalSteps}}", "prev": "Forrige", "next": "N\xE6ste", "tip": "Brug piletasterne til at se andre elementer" }, "UIColorSwatch": { "label": "Farvev\xE6lger {{value}}", "noColorLabel": "Farvev\xE6lger, ingen farve valgt." }, "UIButtonCollapser": { "dropdownLabel": "Handlinger" }, "UIErrorMessage": { "error": { "title": "Alt er ikke tabt." }, "notFound": { "title": "Alle, der vandrer, er ikke tabt." }, "badRequest": { "title": "Der opstod et problem med at indl\xE6se siden." }, "expired": { "title": "Vi beklager." } }, "UIPanelNavigator": { "backButton": "G\xE5 til forrige sk\xE6rmbillede" }, "UILoadingSpinner": { "busyText": "Indl\xE6ser", "completedText": "Indl\xE6st" }, "UISideNav": { "navigationLandmark": "Sekund\xE6r" }, "UISortTH": { "ascendingSort": "Stigende sortering. Tryk for at sortere faldende.", "descendingSort": "Faldende sortering. Tryk for at sortere stigende.", "pressToSort": "Tryk for at sortere." }, "autosizedTextInput": { "charactersRemaining": "{{value}} tegn tilbage" }, "time": { "today": "I dag kl. {{time}}", "yesterday": "I g\xE5r kl. {{time}}", "datetime": "{{date}} kl. {{time}}" }, "progress": { "percentComplete": "{{percent}} fuldendt" }, "datePicker": { "dateSelected": "{{date}} er valgt.", "noDateSelected": "Ingen dato valgt.", "dateBelowMin": "Du skal v\xE6lge en nyere dato", "dateAboveMax": "Du skal v\xE6lge en \xE6ldre dato", "invalidDate": "Ugyldig dato", "today": "I dag", "clear": "Ryd", "placeholder": { "month": "MM", "day": "DD", "year": "\xC5\xC5\xC5\xC5" }, "nextMonth": "N\xE6ste m\xE5ned", "prevMonth": "Forrige m\xE5ned" }, "dateRange": { "startDate": "Startdato", "endDate": "Slutdato", "endDateBeforeStartDate": "Slutdatoen skal ligge efter startdatoen.", "startDateAfterEndDate": "Startdatoen skal ligge f\xF8r slutdatoen.", "to": "til" }, "timePicker": { "placeholder": { "hour": "TT", "minute": "MM" } }, "SelectResultList": { "andMore": "\u2026og {{count}} mere.", "loadMore": "Indl\xE6s mere" } }, "salesUI": { "UIAvatarAdd": { "ariaLabel": "Tilf\xF8j" }, "UIAvatarHoverlay": { "text": "Skift foto" }, "UIChangeArrow": { "decrease": "Fald p\xE5", "increase": "Stigning p\xE5" }, "UICopyInput": { "label": "Tekst", "title": "Kopi\xE9r til udklipsholder", "tooltipCopied": "Kopieret" }, "UIConfirm": { "defaultConfirm": "Ja", "defaultReject": "Nej" }, "UICloseButton": { "label": "Luk" }, "UIDateRangePicker": { "rangeType": { "ALL": "Altid", "THIS_DAY": "I dag", "LAST_DAY": "I g\xE5r", "THIS_WEEK": "Denne uge", "LAST_WEEK": "Sidste uge", "THIS_MONTH": "Denne m\xE5ned", "LAST_MONTH": "Sidste m\xE5ned", "LAST_THIRTY_DAYS": "Seneste 30 dage", "LAST_THREE_MONTHS": "Seneste 3 m\xE5neder", "THIS_QUARTER": "Dette kvartal", "LAST_QUARTER": "Seneste kvartal", "THIS_YEAR": "Dette \xE5r", "LAST_YEAR": "Sidste \xE5r", "CUSTOM": "Brugerdefineret tidsrum" } }, "UIDropdownSelect": { "placeholder": "Ingen v\xE6rdi valgt" }, "UIEditableControls": { "cancel": "Annuller", "save": "Gem" }, "UIExpandableText": { "collapseButtonText": "Vis mindre", "expandButtonText": "Se mere" }, "UIFileInput": { "defaultChangeLabel": "Skift fil", "defaultSelectLabel": "V\xE6lg fil" }, "UIIconRating": { "ariaValueText": "{{value}} af {{maxValue}}" }, "UILink": { "externalTitle": "Link \xE5bnes i et nyt vindue" }, "UILoading": { "title": "Indl\xE6ser\u2026" }, "UILockBadge": { "title": "Denne funktion er l\xE5st" }, "UIPaginator": { "label": "Sidenumre", "pageNumber": { "currentIndicator": "Du er i \xF8jeblikket p\xE5", "description": "Side" }, "firstPage": { "label": "F\xF8rst", "description": "F\xF8rste side" }, "previousPage": { "label": "Forrige", "description": "Forrige side" }, "nextPage": { "label": "N\xE6ste", "description": "N\xE6ste side" }, "lastPage": { "label": "Sidste", "description": "Sidste side" } }, "UIPreviousButton": { "label": "Forrige" }, "UINextButton": { "label": "N\xE6ste" }, "UINumberRating": { "lowRangeLabel": "Meget uenig", "highRangeLabel": "Meget enig" }, "UISearchableSelectInput": { "placeholder": "S\xF8g" }, "UISearchInput": { "placeholder": "S\xF8g", "minimumSearchMessage": { "one": "Indtast 1 tegn mere", "other": "Indtast {{count}} flere tegn" }, "clearButton": "Ryd det indtastede" }, "UISelect": { "allOptionsSelected": "Alle muligheder er valgt", "createOption": "Opret mulighed \u201C{{label}}\u201D", "plusMore": "+ {{count}} mere", "andMore": "\u2026og {{count}} mere.", "loadMore": "Indl\xE6s mere", "noResults": "Ingen resultater fundet", "placeholder": "S\xF8g", "typeToSearch": "Skriv for at s\xF8ge" }, "UITable": { "selectableTableRow": { "toggleSelection": "Skift valg af r\xE6kke" } }, "UITabs": { "moreDropdownLabel": "Mere" }, "UITeaseNotification": { "optionsButtonTooltipText": "Vis muligheder" }, "UITimePicker": { "placeholder": "V\xE6lg et tidspunkt" }, "UIToggle": { "checkedLabel": "TIL", "uncheckedLabel": "FRA" }, "UITypeahead": { "noMatchesFound": "Ingen fundne", "noOptions": "Ingen" }, "UIWizard": { "back": "Tilbage", "cancel": "Annuller", "done": "F\xE6rdig", "next": "N\xE6ste", "stepCount": "Trin {{stepNumber}} af {{stepCount}}" }, "XSSTooltip": { "explanation": "Dette link er blevet deaktiveret for din sikkerhed." } } } } };
  result.translationsLoaded = {
  "foundations-components": {
    "da": "static-1.4501"
  }
};
  result.translationsAvailable = {
  "foundations-components": {
    "af": "static-1.4501",
    "ar-eg": "static-1.4501",
    "bg": "static-1.4501",
    "bn": "static-1.4501",
    "ca-es": "static-1.4501",
    "cs": "static-1.4501",
    "da": "static-1.4501",
    "de": "static-1.4501",
    "el": "static-1.4501",
    "en-gb": "static-1.4501",
    "en": "static-1.4501",
    "es-mx": "static-1.4501",
    "es": "static-1.4501",
    "et": "static-1.4501",
    "fi": "static-1.4501",
    "fr-ca": "static-1.4501",
    "fr": "static-1.4501",
    "he-il": "static-1.4501",
    "hi": "static-1.4501",
    "hr": "static-1.4501",
    "hu": "static-1.4501",
    "id": "static-1.4501",
    "it": "static-1.4501",
    "ja": "static-1.4501",
    "ko": "static-1.4501",
    "lt": "static-1.4501",
    "ms": "static-1.4501",
    "nl": "static-1.4501",
    "no": "static-1.4501",
    "pl": "static-1.4501",
    "pt-br": "static-1.4501",
    "pt-pt": "static-1.4501",
    "ro": "static-1.4501",
    "ru": "static-1.4501",
    "sk": "static-1.4501",
    "sl": "static-1.4501",
    "sv": "static-1.4501",
    "th": "static-1.4501",
    "tl": "static-1.4501",
    "tr": "static-1.4501",
    "uk": "static-1.4501",
    "vi": "static-1.4501",
    "zh-cn": "static-1.4501",
    "zh-hk": "static-1.4501",
    "zh-tw": "static-1.4501"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:foundations-components:da', {version: 'static-1.4501'}); }
})();



(function() {
  var result = { translations: { "da": { "placeholder": "pladsholder" } } };
  result.translationsLoaded = {
  "UIComponents": {
    "da": "static-3.6182"
  }
};
  result.translationsAvailable = {
  "UIComponents": {
    "af": "static-3.6182",
    "ar-eg": "static-3.6182",
    "bg": "static-3.6182",
    "bn": "static-3.6182",
    "ca-es": "static-3.6182",
    "cs": "static-3.6182",
    "da": "static-3.6182",
    "de": "static-3.6182",
    "el": "static-3.6182",
    "en-gb": "static-3.6182",
    "en": "static-3.6182",
    "es-mx": "static-3.6182",
    "es": "static-3.6182",
    "et": "static-3.6182",
    "fi": "static-3.6182",
    "fr-ca": "static-3.6182",
    "fr": "static-3.6182",
    "he-il": "static-3.6182",
    "hi": "static-3.6182",
    "hr": "static-3.6182",
    "hu": "static-3.6182",
    "id": "static-3.6182",
    "it": "static-3.6182",
    "ja": "static-3.6182",
    "ko": "static-3.6182",
    "lt": "static-3.6182",
    "ms": "static-3.6182",
    "nl": "static-3.6182",
    "no": "static-3.6182",
    "pl": "static-3.6182",
    "pt-br": "static-3.6182",
    "pt-pt": "static-3.6182",
    "ro": "static-3.6182",
    "ru": "static-3.6182",
    "sk": "static-3.6182",
    "sl": "static-3.6182",
    "sv": "static-3.6182",
    "th": "static-3.6182",
    "tl": "static-3.6182",
    "tr": "static-3.6182",
    "uk": "static-3.6182",
    "vi": "static-3.6182",
    "zh-cn": "static-3.6182",
    "zh-hk": "static-3.6182",
    "zh-tw": "static-3.6182"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:UIComponents:da', {version: 'static-3.6182'}); }
})();



(function() {
  var result = { translations: { "da": { "app": { "htmlTitle": "Viral Links UI", "welcomeHome": "Velkommen hjem, {{ firstName }}", "yourAppIsReady": "Din app er klar", "aSecondPage": "En ekstra side med plads til mere indhold", "fillPage_jsx": function (createElement, options, props) { return createElement( options, "wrapper", null, "Udfyld denne tomme side med ", createElement( options, "Link", props.linkProps, "komponenter" ), " p\xE5 ", createElement( options, "code", null, props.filename ), "." ); }, "viralLinks": { "forms": { "linkCta": "<strong>Lav dine egne gratis formularer</strong> for at generere leads fra dit websted." }, "liveChat": { "linkCta": "<strong>Tilf\xF8j live chat.</strong> Skab kontakt til bes\xF8gende. Gratis.", "ariaLabel": "Tilf\xF8j live chat. Skab kontakt til bes\xF8gende. Gratis." }, "liveChatIntermediate": { "linkCta": "<strong>[Int] Tilf\xF8j live-chat.</strong> Kom i kontakt med bes\xF8gende. Det er gratis.", "ariaLabel": "[Int] Tilf\xF8j live-chat. Kom i kontakt med bes\xF8gende. Det er gratis." }, "meetings": { "linkCta": "<strong>Opret en gratis side til m\xF8debooking</strong> for at booke m\xF8der hurtigere." } } } } } };
  result.translationsLoaded = {
  "embedded-viral-link-ui": {
    "da": "static-1.3766"
  }
};
  result.translationsAvailable = {
  "embedded-viral-link-ui": {
    "af": "static-1.3766",
    "ar-eg": "static-1.3766",
    "bg": "static-1.3766",
    "bn": "static-1.3766",
    "ca-es": "static-1.3766",
    "cs": "static-1.3766",
    "da": "static-1.3766",
    "de": "static-1.3766",
    "el": "static-1.3766",
    "en-gb": "static-1.3766",
    "en": "static-1.3766",
    "es-mx": "static-1.3766",
    "es": "static-1.3766",
    "et": "static-1.3766",
    "fi": "static-1.3766",
    "fr-ca": "static-1.3766",
    "fr": "static-1.3766",
    "he-il": "static-1.3766",
    "hi": "static-1.3766",
    "hr": "static-1.3766",
    "hu": "static-1.3766",
    "id": "static-1.3766",
    "it": "static-1.3766",
    "ja": "static-1.3766",
    "ko": "static-1.3766",
    "lt": "static-1.3766",
    "ms": "static-1.3766",
    "nl": "static-1.3766",
    "no": "static-1.3766",
    "pl": "static-1.3766",
    "pt-br": "static-1.3766",
    "pt-pt": "static-1.3766",
    "ro": "static-1.3766",
    "ru": "static-1.3766",
    "sk": "static-1.3766",
    "sl": "static-1.3766",
    "sv": "static-1.3766",
    "th": "static-1.3766",
    "tl": "static-1.3766",
    "tr": "static-1.3766",
    "uk": "static-1.3766",
    "vi": "static-1.3766",
    "zh-cn": "static-1.3766",
    "zh-hk": "static-1.3766",
    "zh-tw": "static-1.3766"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:embedded-viral-link-ui:da', {version: 'static-1.3766'}); }
})();


